// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".poster-link[data-v-32889957]{all:unset;width:-moz-fit-content;width:fit-content;display:block;cursor:pointer}", ""]);
// Exports
module.exports = exports;
